export default __webpack_public_path__ + "static/preschool7-0f5d0d0f1a0820e0937c9e20dbed5669.jpg";